module.exports = __webpack_public_path__ + "img/guideFive.77567359.png";